import React, { Component } from 'react'

class Html5Device extends Component {
  render() {
    const { fileSrc } = this.props

    return (
      <div className="phone-container col-md-5">
        <If condition={fileSrc}>
          <embed key={Math.uuid()} src={fileSrc} height={600} width={300} />
        </If>
      </div>
    )
  }
}

export default Html5Device



// WEBPACK FOOTER //
// ./src/components/Html5Device/Html5Device.js